import React, { useEffect, useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { saveInLocalStorage, getFromLocalStorage, removeFromLocalStorage } from "../../utils/Util";
import {STORAGE_KEY} from "../../utils/Constants";
import { addListener } from "./LoginPageHelper";
import "./Login.css";
import { useDispatch } from "react-redux";
import { setAuthenticated } from "../../redux/slices/loginSlice";
import CenterSpinner from "../../components/CenterSpinner";
 
 
const fetchUserProfile = async (accessToken) => {
  try {
    // Fetch user profile
    const profileResponse = await axios.get("https://graph.microsoft.com/v1.0/me", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
 
    // Fetch user photo
    let photoUrl = null;
    try {
      const photoResponse = await axios.get("https://graph.microsoft.com/v1.0/me/photo/$value", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        responseType: "blob",
      });
 
      if (photoResponse && photoResponse.data instanceof Blob) {
        photoUrl = URL.createObjectURL(photoResponse.data);
      }
    } catch (photoError) {
      console.warn("Photo not found or not set in Microsoft 365.");
    }
 
    return {
      ...profileResponse.data,
      photoUrl,
    };
  } catch (error) {
    console.error("Error fetching user profile:", error);
    return null;
  }
};
 
 
const LoginPage = () => {
  const { instance } = useMsal();
  const initialized = useRef(false);
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(false);
 
  const onSuccessfulLogin = async (payload) => {
    saveInLocalStorage(STORAGE_KEY.POWERBI, payload.accessToken);
 
    const userProfile = await fetchUserProfile(payload.accessToken);
    if (userProfile) {
      const { displayName, mail, jobTitle } = userProfile;
      saveInLocalStorage("USER_NAME", displayName);
      saveInLocalStorage("USER_FIRST_NAME", userProfile.givenName);
      saveInLocalStorage("USER_EMAIL", mail);
      saveInLocalStorage("USER_DESIGNATION", jobTitle);
      // saveInLocalStorage("USER_PHOTO", userProfile.photoUrl);
      saveInLocalStorage("USER_PHOTO", userProfile.photoUrl);
    }
    saveInLocalStorage('auth_status', 'authenticated');
 
    dispatch(setAuthenticated({
      status: 'authenticated',
      user: userProfile,
      photo: userProfile.photoUrl,
    }))
 
    // navigate("/dashboard");
  };
 
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      addListener(instance, onSuccessfulLogin, setShowLoader);
    }
 
    const tokenExpire = getFromLocalStorage(STORAGE_KEY.TOKEN_EXPIRE);
    if (STORAGE_KEY.TOKEN_EXPIRE === tokenExpire) {
      toast.success("Token has expired, Please login");
      removeFromLocalStorage(STORAGE_KEY.TOKEN_EXPIRE);
    }
  }, [instance]);
 
  const handleLogin = () => {
    setShowLoader(true);
    instance.loginRedirect();
  };
 
  return (
   <div className="login-page">
      <img src={require('../../images/Kshema-element.png')} alt="Logo" className="imageelement mb-4" />
       <div className="login-page">
       
         <div className="login-form">
         
           <link
             rel="stylesheet"
             href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css"
           />
           <div className="leftside">
            <img src={require('../../images/logo-15.png')} alt="Logo" className="logo" />
           <h3 className="htag"> Power BI   </h3>
           <p>Login to get started</p>
           </div>
           <button type="button" onClick={handleLogin} className="login-button">
             Login
           </button>
         </div>
       </div>
       <CenterSpinner showLoader={showLoader} />
     </div>
  );
};
export default LoginPage;